module.exports = __webpack_public_path__ + "img/ghbank.f867387d.jpg";